import firebase from "../../firebase";

export default function({ officeId, email }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "billingAdmin",
        funcName: "changeCustomerEmail",
        data: { officeId, email }
    });
}
